import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

export function SortableHeader({ label, sortKey, currentSort, onSort, className = '' }) {
  const isActive = currentSort?.key === sortKey;
  const icon = isActive
    ? (currentSort.dir === 'asc' ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />)
    : <ArrowUpDown className="w-3 h-3 opacity-30" />;
  return (
    <th className={`px-4 py-2.5 font-semibold select-none cursor-pointer hover:bg-accent/30 transition-colors ${className}`}
      onClick={() => onSort(sortKey)} role="columnheader" aria-sort={isActive ? (currentSort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <span className="inline-flex items-center gap-1">{label} {icon}</span>
    </th>
  );
}

export function sortData(data, key, dir) {
  if (!key) return data;
  return [...data].sort((a, b) => {
    let av = a[key], bv = b[key];
    if (av == null) av = '';
    if (bv == null) bv = '';
    if (typeof av === 'number' && typeof bv === 'number') return dir === 'asc' ? av - bv : bv - av;
    return dir === 'asc' ? String(av).localeCompare(String(bv)) : String(bv).localeCompare(String(av));
  });
}

export const toggleSort = (setter) => (key) =>
  setter(prev => ({ key, dir: prev.key === key && prev.dir === 'asc' ? 'desc' : 'asc' }));
